import { HistoryViewDetails } from './history-view-details';
import styles from './styles.module.scss';
import { InlineSvg } from 'components/svg';
import { ID } from 'components/table/types';
import { useEmployeePersonalHistoryShortDetailsQuery } from 'features/employees/api/repositories/use-employee-personal-history-short-details.query';
import moment from 'moment';
import { FC, useState } from 'react';

type Props = {
  id: ID;
};

export const HistoryDetails: FC<Props> = ({ id }) => {
  if (!id) return null;

  const [take, setTake] = useState<number>(3);
  const [loadHistories, setLoadHistories] = useState<boolean>(true);

  const loadHistoryHandler = () => {
    if (take === 3) setTake(0);
    else setTake(3);

    setLoadHistories(true);
  };

  const [viewId, setViewId] = useState<number | null | undefined>(null);

  const { data: histories, isLoading } = useEmployeePersonalHistoryShortDetailsQuery(
    {
      id: id,
      take: take
    },
    undefined,
    {
      enabled: loadHistories,
      onSuccess(data) {
        setLoadHistories(false);
      }
    }
  );

  if (!histories?.length) return null;

  return (
    <>
      <div className="card mb-5 mb-xl-10">
        <div
          className="card-header border-0 cursor-pointer"
          role="button"
          data-bs-toggle="collapse"
          data-bs-target="#kt_employee_health-care-details"
          aria-expanded="true"
          aria-controls="kt_employee_health-care-details"
        >
          <div className="card-title m-0">
            <h3 className="fw-bolder m-0">Changes History</h3>
          </div>
        </div>

        <div id="kt_from_employee_health-care-details" className="collapse show">
          <div className="card-body border-top py-0">
            <table className={styles.viewHistoryTable}>
              <tbody>
                {histories.map((x) => (
                  <tr key={x.id}>
                    <td className={styles.viewHistoryTimeCell}>{moment(x.createDt).format('DD/MM/YYYY - hh:mm')}</td>
                    <td>Changed by {x.createUserName ?? 'User'}</td>
                    <td>
                      <button type="button" className={styles.viewHistoryButton} onClick={() => setViewId(x.id)}>
                        View
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            {take > 0 && (
              <button
                type="button"
                className="btn btn-light-primary me-5"
                onClick={() => loadHistoryHandler()}
                disabled={isLoading}
              >
                {!isLoading && (
                  <span className="indicator-label">
                    View
                    <InlineSvg path="/media/icons/duotune/arrows/arr072.svg" className="svg-icon-5 m-0" />
                  </span>
                )}
                {isLoading && (
                  <span className="indicator-progress" style={{ display: 'block' }}>
                    Please wait... <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                  </span>
                )}
              </button>
            )}
          </div>
        </div>
      </div>
      {viewId && <HistoryViewDetails id={viewId} onClose={() => setViewId(null)} />}
    </>
  );
};
